import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { NewbuildingMvkContext } from '../shared/context';
import { fetchFloorPlan } from '../services';
export var useFloorPlan = function useFloorPlan(_ref) {
  var newbuildingId = _ref.newbuildingId,
    houseId = _ref.houseId,
    sectionId = _ref.sectionId;
  var _React$useContext = React.useContext(NewbuildingMvkContext),
    httpApi = _React$useContext.httpApi,
    logger = _React$useContext.logger;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isError = _React$useState2[0],
    setIsError = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoading = _React$useState4[0],
    setIsLoading = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    floorPlan = _React$useState6[0],
    setFloorPlan = _React$useState6[1];
  var loadPlan = React.useCallback(function (filters) {
    setIsError(false);
    setIsLoading(true);
    fetchFloorPlan({
      httpApi: httpApi,
      logger: logger,
      params: {
        newbuildingId: newbuildingId,
        filters: filters
      }
    }).then(function (response) {
      setIsLoading(false);
      if (response) {
        setFloorPlan(response.floorPlan || null);
      } else {
        setIsError(true);
        setFloorPlan(null);
      }
    });
  }, [newbuildingId, httpApi, logger]);
  React.useLayoutEffect(function () {
    loadPlan({
      houseId: houseId || undefined,
      sectionId: sectionId || undefined
    });
  }, [houseId, sectionId, loadPlan]);
  return {
    isError: isError,
    isLoading: isLoading,
    floorPlan: floorPlan,
    loadPlan: loadPlan
  };
};